// extracted by mini-css-extract-plugin
export default {"carousel":"styles_carousel__gS06b"};